import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  Input,
  OnChanges,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Icons } from '../../models/icons.model';
import { SvgIconCacheService } from './svg-icon-cache.service';

@Component({
  selector: 'csl-svg-icon',
  standalone: true,
  template: `@if (svgIcon) {
    <span [innerHTML]="svgIcon" class="flex h-full w-full items-center justify-center"></span>
  }`,
  styleUrl: './svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent implements OnChanges {
  private readonly svgIconCacheService = inject(SvgIconCacheService);
  private readonly sanitizer: DomSanitizer = inject(DomSanitizer);
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly destroyedRef = inject(DestroyRef);

  @Input() public name?: Icons | string;

  public svgIcon?: SafeHtml;

  public ngOnChanges(): void {
    if (!this.name) {
      this.svgIcon = '';
      return;
    }
    this.svgIconCacheService
      .get(this.name)
      .pipe(takeUntilDestroyed(this.destroyedRef))
      .subscribe((value) => {
        this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
        this.cdr.detectChanges();
      });
  }
}
